import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface industry {
  value: string;
  label: string;
}
export interface MerchantInfoStateIF {
  id: number;
  merchantType: string;
  merchantTypeNo: number;
  merchantName: string;
  merchantNameKana: string;
  merchantNameEng: string;
  industry: industry;
  industrySupplement: string;
  permitName: string;
  permitType: string;
  sales: string | undefined;
  pref: string;
  prefKana: string;
  city: string;
  cityKana: string;
  area: string;
  areaKana: string;
  koazaChome: string;
  koazaChomeKana: string;
  banchi: string;
  banchiKana: string;
  buildingName: string;
  buildingNameKana: string;
  phoneNumber: string;
  postalCode: string;
}

interface MerchantInfos {
  merchant: MerchantInfoStateIF[];
}

const initialState = {
  merchant: [],
} as MerchantInfos;

const merchantInfoSlice = createSlice({
  name: "merchantInfoSlice",
  initialState,
  reducers: {
    updateMerchantInfo: (
      state,
      action: PayloadAction<{
        merchant: MerchantInfoStateIF[];
      }>
    ) => {
      const { merchant } = action.payload;
      state.merchant = merchant;
    },
  },
});

export const { updateMerchantInfo } = merchantInfoSlice.actions;

export default merchantInfoSlice.reducer;
